export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '流水号',
            fixed: 'left',
            minWidth: 150
        },
		{
		    prop: 'orgName',
		    label: '渠道归属',
		    minWidth: 100
		},
		{
		    prop: 'carNo',
		    label: '车牌号',
		    minWidth: 100
		},
		{
		    prop: 'order_no',
		    label: '订单号',
		    minWidth: 200
		},
		{
		    prop: 'create_time',
		    label: '生成时间',
		    minWidth: 150
		},
        {
            prop: 'pay_status',
            label: '状态',
            minWidth: 100,
			render: ({ pay_status }) => {
			    return pay_status ? '支付完成' : '待支付'
			}
        },
        {
            prop: 'pay_money',
            label: '收款金额(元)',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'pay_channel',
            label: '支付平台',
            sortable: true,
            minWidth: 100
        },
		{
		    prop: 'pay_time',
		    label: '支付时间',
		    sortable: true,
		    minWidth: 150
		},
        {
            prop: 'pay_type',
            label: '支付方式',
            sortable: true,
            minWidth: 100,
			render: ({ pay_type }) => {
			    return pay_type ? '支付宝' : '微信'
			}
        },
		{
		    prop: 'realname',
		    label: '业务员',
		    minWidth: 150
		}
    ]
}

export default {}